export const PL = {
  language: "Polski",
  home: {
    header: 'Witam, nazywam się Kamila Grusza.',
    subheader: 'Jestem Front End Developerem.'
  },
  resume: {
    cv: 'https://drive.google.com/file/d/1iw_4F0owoVYD2ouUElEMN-0fZW9ruTlN/view?usp=sharing',
    cvText: 'Kliknij tutaj, aby obejrzeć moje CV',
    intro: `Rok temu odkryłam swoją pasję do tworzenia aplikacji internetowych i od tego czasu z przyjemnością kontynuuję swoją przygodę z programowaniem i uczeniem się nowych rzeczy. Jestem osobą kreatywną, z otwartym umysłem i nie bojącą się wyzwań. Moje umiejętności interpersonalne pozwalają mi doskonale pracować w grupie i
    sprawnie nawiązywać kontakty. Wyróżnia mnie wysoka kultura osobista oraz chęć do ciągłej nauki. Jako mój obecny cel zawodowy skupiam się na własnym rozwoju w zakresie umiejętności programistycznych oraz znajomości nowych technologii.`,
    skills: 'Moje umiejętności'
  },
  projects: {
    matmopoly: {
      header: 'Matmopoly',
      text: `Projekt powstał w celu zwiększenia biegłości w liczeniu tabliczki mnożenia wśród dzieci z klas 4-8, ponieważ zauważono ewidentne braki tej umiejętności. Ta aplikacja była również okazją do nauki Vue.js.\nUtworzono za pomocą: VueJS.\nLink: *https://github.com/kami3la/Monopoly`
    },
    myPlants: {
      header: 'MyPlants',
      text: `Aplikacja dla miłośników roślin. Projekt korzysta z wcześniej utworzonego REST API.\nUtworzony za pomocą: ReactJS, SCSS, NodeJS, Express.js, MongoDB, Mongoose, TypeScript, Heroku, Lucidchart, ESLint, StyleLint, Jest, Jira, Scrum, Figma.\nLink: *https://github.com/LittleCodersCrew/CodersCamp2020.Project.React.MyPlants`
    },
    starWars: {
      header: 'Star Wars Quiz',
      text: `Ten projekt to quiz sprawdzający wiedzę z uniwersum Gwiezdnych Wojen.\nUtworzony za pomocą: HTML, SCSS, JavaScript, Star Wars API, Jest, Trello, Scrum, Figma, metodologia BEM.\nLink: *https://github.com/ruljin/CodersCamp2020.Project.JavaScript.StarWarsQuiz`
    },
    yahtzee: {
      header: 'Yahtzee Game',
      text: `Ten projekt to aplikacja do gry w kości o nazwie Yahtzee.\nUtworzony za pomocą: HTML, SCSS, TypeScript, Webpack, Jest, ESLint, StyleLint, HTML-validate, Jira, Scrum, Figma, metodologia BEM.\nLink: *https://github.com/ruljin/CodersCamp2020.Project.TypeScript.YahtzeeGame`
    },
    js30: {
      header: 'JavaScript 30',
      text: `Ten projekt został stworzony w ramach "30 Day Vanilla JS Coding Challenge", którego autorem jest WesBos.\nUtworzony za pomocą: HTML, CSS, JavaScript.\nLink: *https://github.com/kami3la/JavaScript30`
    },
    link: 'Kliknij tutaj !'
  },
  about: {
    about: {
      header: 'Kilka słów o tym kim jestem',
      text: `Mam 24 lata i mieszkam w Poznaniu. Miałam zostać nauczycielem matematyki i informatyki, ale podczas moich studiów zetknęłam się z programowaniem, które bardzo mnie zainteresowało. Wtedy 
      postanowiłam rozpocząć naukę programowania webowego, a moja pasja i miłość do kodowania tylko rosły. Programowanie mnie uszczęśliwa, daje mi wyzwania, które tak bardzo lubię, a także zaspokaja moją chęć do 
      ciągłej nauki. Poza programowaniem uwielbiam również podróżować, poznawać nowych ludzi, pić dobrą kawę, przebywać w otoczeniu zwierząt, rozwiązywać zagadki i po prostu przebywać na łonie natury.`
    },
    hobby: {
      header: 'Moje hobby',
      games: {
        title: 'Gry - siatkówka',
        text: `Uwielbiam wszelkiego rodzaju gry, zwłaszcza te logiczne lub zespołowe. Dlatego w wolnym czasie chętnie rozwiązuję krzyżówki i nonogramy, gram w gry komputerowe i planszowe oraz chodzę do escape roomów.
        Natomiast moim ulubionym sportem jest siatkówka, którą trenowałam przez 6 lat. Zawsze dobrze się przy tym bawiłam i nadal lubię grać z moimi przyjaciółmi, gdy tylko nadarzy się okazja. Dlatego za każdym razem, gdy wybieramy się nad jezioro, na kemping lub nad morze, zawsze zabieramy ze sobą piłkę do siatkówki.`
      },
      plants: {
        title: 'Rośliny doniczkowe',
        text: `Rośliny doniczkowe to moja kolejna pasja. Uważam, że kolorowe donice z zadbanymi roślinami są niezbędnym elementem mojego domu. Ogromną radość sprawia mi, gdy moja roślinka wypuszcza nowy liść,
        kwiat lub nowe dziecko. Wszystko zaczęło się od zakupu jednej rośliny i zanim się zorientowałem, na moich półkach znajdowała się cała kolekcja roślin. W tym momencie nie wyobrażam sobie, aby mój parapet nie był przyozdobiony roślinkami.`
      },
      traveling: {
        title: 'Podróżowanie',
        text: `Bardzo ważne jest dla mnie podróżowanie zarówno po Polsce, jak i do innych krajów. Dlatego zawsze staram się odwiedzać nowe miejsca i odkrywać obce kultury. Moim ulubionym rodzajem podróży jest odwiedzanie jak największej liczby miejsc i robienie jak największej ilości rzeczy, więc zwykle nie 
        ograniczam się tylko do jednego celu podróży. Właśnie dlatego kiedyś pojechałam do Hiszpanii autostopem. Jest to najszybszy sposób na poznanie wielu nowych miejsc, a także ludzi i ich historii.`
      },
      billards: {
        title: 'Bilard',
        text: `Moje ostatnie zainteresowanie, tym razem dość niespotykane, to bilard. Wieczorna gra w bilarda z przyjaciółmi to dla mnie idealnie spędzony czas. Gram towarzysko od wielu lat i nigdy się tym nie
        znudzę. Moją pasję podzielają również moi rodzice, którzy zdecydowali się na zakup stołu bilardowego, co z pewnością było bardzo mądrą decyzją podczas trwania pandemii. Bardzo lubię montować meble według
        algorytmu instrukcji, ale muszę przyznać, że złożenie stołu bilardowego było dla mnie nie lada wyzwaniem.`
      }
    },
    travels: {
      title: 'Moje podróże'
    }
  }
};
  
export const EN = {
  language: "English",
  home: {
    header: 'Hello, my name is Kamila Grusza',
    subheader: 'I am a Front End Developer'
  },
  resume: {
    cv: 'https://drive.google.com/file/d/1i6GU9hhjjpWukk_Dm1BVO6ICjP2PqbzP/view?usp=sharing',
    cvText: 'Click here and check out my CV',
    intro: `Web developer with 1+ years of Front-End experience and passion for responsive webside design. Constantly seeking for new challenges that will
    expand my skill set. Working effectively both in a team and individually. As my current professional goal, I set myself, above all, further development, gaining
    experience and new skills. I am looking for an opportunity to live and grow in a foreign environment.`,
    skills: 'My skills'
  },
  projects: {
    matmopoly: {
      header: 'Matmopoly',
      text: `The project was created to increase the proficiency in calculating the multiplication table among children in grades 4-8, as evident deficiencies of this skill were noticed. This application was also an opportunity to learn Vue.js.\nCreated with: VueJS.\nLink: *https://github.com/kami3la/Monopoly`
    },
    myPlants: {
      header: 'MyPlants',
      text: `Application for plant lovers. The project uses the previously created REST API.\nCreated with: ReactJS, SCSS, NodeJS, Express.js, MongoDB, Mongoose, TypeScript, Heroku, Lucidchart, ESLint, StyleLint, Jest, Jira, Scrum, Figma.\nLink: *https://github.com/LittleCodersCrew/CodersCamp2020.Project.React.MyPlants`
    },
    starWars: {
      header: 'Star Wars Quiz',
      text: `This project is a quiz that tests the knowledge of the Star Wars universe.\nCreated with: HTML, SCSS, JavaScript, Star Wars API, Jest, Trello, Scrum, Figma, BEM methodology.\nLink: *https://github.com/ruljin/CodersCamp2020.Project.JavaScript.StarWarsQuiz`
    },
    yahtzee: {
      header: 'Yahtzee Game',
      text: `This project is an application to play dice game called Yahtzee.\nCreated with: HTML, SCSS, TypeScript, Webpack, Jest, ESLint, StyleLint, HTML-validate, Jira, Scrum, Figma, BEM methodology.\nLink: *https://github.com/ruljin/CodersCamp2020.Project.TypeScript.YahtzeeGame`
    },
    js30: {
      header: 'JavaScript 30',
      text: `This project was created as part of "30 Day Vanilla JS Coding Challenge" authored by WesBos.\nCreated with: HTML, CSS, JavaScript.\nLink: *https://github.com/kami3la/JavaScript30`
    },
    link: 'Click here !'
  },
  about: {
    about: {
      header: 'A few words about who I am',
      text: `I am 24 years old and I live in Poznań, Poland. I was supposed to become a mathematics and computer science teacher, but during my 
      studies I encountered programming and I got extremely interested in it. Then I decided to start learning web programming and my passion and love for coding only grew. Programming makes me 
      happy, it gives me challenges that I like so much, and it satisfies my desire for continuous learning. Apart from programming, I also love traveling, meeting new people, drinking good 
      coffee, being surrounded by animals, solving puzzles and just being out in nature.`
    },
    hobby: {
      header: 'My hobbies',
      games: {
        title: 'Games - volleyball',
        text: `I love all kinds of games, especially logical or team games. That is why in my spare time I like to solve crosswords and nonograms, play computer and board games and go to escape rooms. But my 
        favorite sport is volleyball, which I trained for 6 years. I've always had a lot of fun doing it and still enjoy playing with my friends whenever the opportunity arises. That's why every time we go to the lake, camping or to the seaside, we always take a volleyball ball with us.`
      },
      plants: {
        title: 'Houseplants',
        text: `Potted plants are my next passion. I believe that colorful pots with well-kept plants are an indispensable element of my home. It always gives me great joy when my plant produces a new leaf, 
        flower or new baby. It all started with buying one plant, and before I knew it, there was a whole collection of plants on my shelves. At this point, I cannot imagine my window sill not being decorated with plants.`
      },
      traveling: {
        title: 'Traveling',
        text: `It is very important for me to travel both in Poland and to other countries. That is why I always try to visit new places and discover foreign cultures. My favorite type of trip is to visit and do as many things as possible, so I usually don't limit myself to just one destination. That's why I hitchhiked 
        to Spain once. It is the fastest way to meet many new places, as well as people and their stories.`
      },
      billards: {
        title: 'Billards',
        text: `My last interest, quite unusual this time, is billiards. An evening game of pool with my friends is the perfect time for me. I have been playing pool for many years and I never get tired 
        of it. My passion is also shared by my parents who decided to buy a pool table, which was certainly a very wise decision during the recent lockdowns. I really like assembling furniture according to the 
        instruction algorithm, but I have to admit that assembling the pool table was quite a challenge.`
      }
    },
    travels: {
      title: 'My travels'
    }
  }
};
